<template>
  <div class="container" v-if="show">
    <div class="logo"></div>
    <div class="tit"></div>
    <div class="icon"></div>
    <div class="btn_sub" @click="goNext">开始活动</div>
<!--    <van-button round block type="info" native-type="submit" color="#952112" class="btn_sub" @click="goNext"><span style="color: #fbca67;">开始活动</span></van-button>-->
  </div>
</template>

<script>
let that,token;
import {Toast, Form, Field, Button, Popup, Picker} from 'vant';
export default {
  name: "Home",
  components:{
    'van-form':Form,
    'van-field':Field,
    'van-button':Button,
    'van-popup':Popup,
    'van-picker':Picker,
  },
  data(){
    return{
      show:false,
      team:'',
      form_arr:{
        name:'',
        phone:'',
      },
      showPicker:false,
      sub_status:true,
    }
  },
  created() {
    that=this;
    /*if(this.$route.query.is_test){
      this.isOpen=true;
    }*/
    token=localStorage.getItem('token');
    if(token){
      this.show=true;
      this.getData();
    }else{
      this.$Global.goLogin();
    }
  },
  methods:{
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    goNext() {
      this.$router.replace('/index.html');
    },
    onConfirm(value,index) {
      this.team = value;
      this.form_arr.team = index+1;
      this.showPicker = false;
    },
    sub(){
      if(!this.sub_status){
        return false;
      }
      this.sub_status=false;
      this.$http(this.$Global.api_base+'login.php',this.form_arr,'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        that.sub_status=true;
        if(res.status==1){
          if(res.token){
            localStorage.setItem('token',res.token);
            that.token=res.token;
            that.show=false;
            that.isLogin=true;
            that.$router.push('/story_cat.html');
          }else{
            Toast('登录失败，请重试');
          }
        }else{
          Toast(res.info);
        }
      }).catch(function (error) {
        console.log(error);
        /*Toast(error);*/
      });
    },
    getData() {
      this.$http(that.$Global.api_base+'checkLogin.php',{},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.status==1){
          // that.$router.push('/story_cat.html');
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  min-height: 13.24rem;
  height: 100%;
  position: relative;
  flex-shrink: 0;
  overflow-y: auto;
}
.logo{
  width: 5.71rem;
  height: .58rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 5vh;
  background: var(--home_logo) no-repeat;
  background-size: 100% auto;
}
.tit{
  width: 6.68rem;
  height: .96rem;
  position: relative;
  background: var(--home_tit) no-repeat;
  background-size: 100% auto;
  flex-shrink: 0;
  margin: 12vh auto 0;
}
.icon{
  width: 5.33rem;
  height: 5.21rem;
  position: relative;
  background: var(--home_icon) no-repeat;
  background-size: 100% auto;
  flex-shrink: 0;
  margin: 10vh auto 0;
}
  .btn_sub{
    background: url("https://h5storage.xingflash.com/modern_enroll_2024/images/btn_bg.png") no-repeat;
    background-size: 100% auto;
    width: 4.83rem;
    height: .79rem;
    line-height: .79rem;
    font-size: .32rem;
    margin: 10vh auto 0;
    text-align: center;
    color: #ffffff;
    font-weight: bold;
    letter-spacing: .02rem;
  }
@media screen and (max-height: 400px) {
  .container{
    background-size: 100% auto;
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/Home.vue